import {
  Checkbox,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import React from 'react';
import { Controller, UseFormMethods } from 'react-hook-form';
import { SvgInfo, SvgInfoOutlined } from 'src/components/icons';
import { COPYRIGHT_LICENSE, COPY_RIGHTS } from 'src/constants/copyrights';
import { SIDE_MENU } from './types';

interface PermissionsSectionProps {
  section: string;
  control: UseFormMethods['control'];
  showCopyright?: boolean;
}

function PermissionsSection({
  section,
  control,
  showCopyright = true,
}: PermissionsSectionProps) {
  return (
    <Stack
      display={section === SIDE_MENU.PERMISSIONS ? 'flex' : 'none'}
      spacing={5}
      direction="column"
      width="100%"
    >
      {/* Project Copyrights */}
      {showCopyright && (
        <FormControl id="copyright">
          <FormLabel color="gray.700" display="flex" alignItems="center">
            <Text as="b">Copyright & License</Text>{' '}
            <Tooltip label={COPYRIGHT_LICENSE}>
              <SvgInfoOutlined fontSize="20px" color="gray.300" />
            </Tooltip>
          </FormLabel>
          <Controller
            name="copyright"
            control={control}
            defaultValue=""
            render={({ onChange, value }) => (
              <RadioGroup onChange={onChange} value={value}>
                <Stack spacing={4}>
                  {Object.keys(COPY_RIGHTS).map((c) => (
                    <Stack key={c} spacing={2} direction="row">
                      <Radio value={COPY_RIGHTS[c].shortname}>
                        {COPY_RIGHTS[c].name}
                      </Radio>
                      <Tooltip
                        zIndex={1401} // https://github.com/chakra-ui/chakra-ui/issues/1604
                        label={COPY_RIGHTS[c].description}
                        placement="right-start"
                      >
                        <SvgInfo fontSize="16px" color="gray.300" />
                      </Tooltip>
                    </Stack>
                  ))}
                </Stack>
              </RadioGroup>
            )}
          />
        </FormControl>
      )}

      {/* Project Comments Disabled */}
      <FormControl id="disabledComment">
        <FormLabel color="gray.700">
          <Text as="b">Comments</Text>
        </FormLabel>
        <Controller
          name="disabledComment"
          control={control}
          render={({ onChange, value }) => (
            <Checkbox
              isChecked={value}
              onChange={(e) => onChange(e.target.checked)}
            >
              <Text as="b" color="gray.500" fontSize="sm">
                Disable comments on this project
              </Text>
            </Checkbox>
          )}
        />
      </FormControl>
    </Stack>
  );
}

export default PermissionsSection;
